import api from './api'; // Your configured Axios instance


export const createExpense = async (payload) => {
    const { data } = await api.post("/expense", payload);
    return data.data;
  };
  
  // ✅ Create bulk expenses
  export const createBulkExpenses = async (payload) => {
    // expects { expenses: [...] }
    const { data } = await api.post("/expenses/bulk", payload);
    return data.data;
  };

/**
 * Fetches expenses from backend.
 * @param {number} page
 * @param {number} limit
 * @returns {Promise<{expenses: Array, page: number, pages: number, total: number}>}
 */
export const getExpenses = async ({
  employeeId = "",
  page = 1,
  limit = 10,
  categoryId = "",
  startDate = "",
  endDate = "",
  status = "",
  search = "",
} = {}) => {
  const params = new URLSearchParams();

  if (employeeId) params.append("employeeId", employeeId);
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (categoryId) params.append("categoryId", categoryId);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (status && status !== "all") params.append("status", status); // ✅ Add status
  if (search) params.append("search", search); // ✅ Add search

  const { data } = await api.get(`/expense?${params.toString()}`);
  
  return {
    expenses: data.data,
    count: data.count,
    total: data.total,
    page: data.page,
    pages: data.pages,
    message: data.message,
  };
};



export const getExpensesCategory = async () => {
  const { data } = await api.get("/categoryExpense");
  return {
    expenses: data.data, // ✅ directly return the array
  };
};

export const updateExpense = async ({ expenseId, data }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("No token found in localStorage.");
  }
  const response = await api.put(`/expense/${expenseId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

export const getEmployeeExpenses = async ({
  page = 1,
  limit = 10,
  startDate = "",
  endDate = "",
  search = "",
} = {}) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (search) params.append("search", search); // ✅ Already there

  const { data } = await api.get(`/expense/analytics/employee-expense?${params.toString()}`);
  
  return {
    expenses: data.data,
    count: data.count,
    total: data.total,
    page: data.page,
    pages: data.pages,
    message: data.message,
  };
};


export const getExpenseByCategory = async ({
  categoryId = "",
  page = 1,
  limit = 10,
  startDate = "",
  endDate = "",
  search = "",
} = {}) => {
  const params = new URLSearchParams();

  if (categoryId) params.append("categoryId", categoryId);
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (search) params.append("search", search);

  const { data } = await api.get(`/expense/analytics/category?${params.toString()}`);
  
  return {
    employees: data.data,
    total: data.total,
    page: data.page,
    limit: data.limit,
    totalPages: data.totalPages,
    message: data.message,
  };
};


export const getCategorySummary = async ({
  page = 1,
  limit = 10,
  startDate = "",
  endDate = "",
  search = "",
} = {}) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (search) params.append("search", search);

  const { data } = await api.get(`/expense/analytics/category-summary?${params.toString()}`);
  
  return {
    categories: data.data,
    total: data.total,
    page: data.page,
    limit: data.limit,
    totalPages: data.totalPages,
    message: data.message,
  };
};

export const deleteExpense = async (expenseId) => {
  const { data } = await api.delete(`/expense/${expenseId}`);
  return data;
};